export const SUPPORT_LEVEL_MAP = {
  GKE: {
    // https://cloud.google.com/kubernetes-engine/docs/release-schedule
    '1.24': [
      {
        end_date: new Date(2024, 0, 8).getTime() / 1000,
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
    ],
    '1.25': [
      {
        end_date: new Date(2024, 2, 30).getTime() / 1000,
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
    ],
    '1.26': [
      {
        end_date: new Date(2024, 5, 30).getTime() / 1000, // 2024-06-30
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
    ],
    '1.27': [
      {
        end_date: new Date(2024, 9, 1).getTime() / 1000, // 2024-10-01
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2025, 5, 14).getTime() / 1000, // 2025-06-14
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.28': [
      {
        end_date: new Date(2025, 1, 4).getTime() / 1000, // 2025-02-04
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 0, 9).getTime() / 1000, // 2026-01-09
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.29': [
      {
        end_date: new Date(2025, 3, 12).getTime() / 1000, // 2025-04-12
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 0, 25).getTime() / 1000, // 2026-01-25
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.30': [
      {
        end_date: new Date(2025, 8, 30).getTime() / 1000, // 2025-09-30
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 6, 30).getTime() / 1000, // 2026-07-30
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.31': [
      {
        end_date: new Date(2026, 0, 16).getTime() / 1000, // 2026-01-16
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 9, 22).getTime() / 1000, // 2026-10-22
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.32': [
      {
        end_date: new Date(2026, 3, 27).getTime() / 1000, // 2026-04-27
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 1, 11).getTime() / 1000, // 2027-02-11
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.33': [
      {
        end_date: new Date(2026, 7, 3).getTime() / 1000, // 2026-08-03
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 5, 3).getTime() / 1000, // 2027-06-03
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.34': [
      {
        end_date: new Date(2027, 0, 25).getTime() / 1000, // 2027-01-25
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 10, 25).getTime() / 1000, // 2027-11-25
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.35': [
      {
        end_date: new Date(2027, 3, 11).getTime() / 1000, // 2027-04-11
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2028, 1, 11).getTime() / 1000, // 2028-02-11
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.36': [
      {
        end_date: new Date(2027, 8, 30).getTime() / 1000, // 2027-09-30 (Q3 2027)
        name: 'GKE Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2028, 5, 30).getTime() / 1000, // 2028-06-30 (Q2 2028)
        name: 'GKE Extended Support',
        type: 'LongTermSupport',
      },
    ],
  },
  AKS: {
    // https://learn.microsoft.com/en-us/azure/aks/supported-kubernetes-versions?tabs=azure-cli#aks-kubernetes-release-calendar
    '1.25': [
      {
        end_date: new Date(2024, 0, 14).getTime() / 1000,
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
    ],
    '1.26': [
      {
        end_date: new Date(2024, 2, 31).getTime() / 1000, // 2024-03-31
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
    ],
    '1.27': [
      {
        end_date: new Date(2024, 6, 31).getTime() / 1000, // 2024-07-31
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2025, 6, 31).getTime() / 1000, // 2025-07-31
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.28': [
      {
        end_date: new Date(2025, 0, 31).getTime() / 1000, // 2025-01-31
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 1, 28).getTime() / 1000, // 2026-02-28
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.29': [
      {
        end_date: new Date(2025, 2, 31).getTime() / 1000, // 2025-03-31
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 3, 30).getTime() / 1000, // 2026-04-30
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.30': [
      {
        end_date: new Date(2025, 7, 31).getTime() / 1000, // 2025-08-31
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 6, 31).getTime() / 1000, // 2026-07-31
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.31': [
      {
        end_date: new Date(2025, 10, 30).getTime() / 1000, // 2025-11-30
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 10, 30).getTime() / 1000, // 2026-11-30
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.32': [
      {
        end_date: new Date(2026, 2, 31).getTime() / 1000, // 2026-03-31
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 2, 31).getTime() / 1000, // 2027-03-31
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.33': [
      {
        end_date: new Date(2026, 5, 30).getTime() / 1000, // 2026-06-30
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 5, 30).getTime() / 1000, // 2027-06-30
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.34': [
      {
        end_date: new Date(2026, 10, 30).getTime() / 1000, // 2026-11-30
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 10, 30).getTime() / 1000, // 2027-11-30
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.35': [
      {
        end_date: new Date(2027, 2, 31).getTime() / 1000, // 2027-03-31
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2028, 2, 31).getTime() / 1000, // 2028-03-31
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
    '1.36': [
      {
        end_date: new Date(2027, 5, 30).getTime() / 1000, // 2027-06-30
        name: 'AKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2028, 5, 30).getTime() / 1000, // 2028-06-30
        name: 'AKS Long Term Support',
        type: 'LongTermSupport',
      },
    ],
  },
  EKS: {
    // https://docs.aws.amazon.com/eks/latest/userguide/kubernetes-versions.html#kubernetes-release-calendar
    '1.23': [
      {
        end_date: new Date(2023, 9, 11).getTime() / 1000,
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2024, 9, 11).getTime() / 1000,
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.24': [
      {
        end_date: new Date(2024, 0, 31).getTime() / 1000,
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2025, 0, 31).getTime() / 1000,
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.25': [
      {
        end_date: new Date(2024, 4, 1).getTime() / 1000,
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2025, 4, 1).getTime() / 1000,
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.26': [
      {
        end_date: new Date(2024, 5, 11).getTime() / 1000, // 2024-06-11
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2025, 5, 11).getTime() / 1000, // 2025-06-11
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.27': [
      {
        end_date: new Date(2024, 6, 24).getTime() / 1000, // 2024-07-24
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2025, 6, 24).getTime() / 1000, // 2025-07-24
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.28': [
      {
        end_date: new Date(2024, 10, 26).getTime() / 1000, // 2024-11-26
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2025, 10, 26).getTime() / 1000, // 2025-11-26
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.29': [
      {
        end_date: new Date(2025, 2, 23).getTime() / 1000, // 2025-03-23
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 2, 23).getTime() / 1000, // 2026-03-23
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.30': [
      {
        end_date: new Date(2025, 6, 23).getTime() / 1000, // 2025-07-23
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 6, 23).getTime() / 1000, // 2026-07-23
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.31': [
      {
        end_date: new Date(2025, 10, 26).getTime() / 1000, // 2025-11-26
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2026, 10, 26).getTime() / 1000, // 2026-11-26
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.32': [
      {
        end_date: new Date(2026, 2, 23).getTime() / 1000, // 2026-03-23
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 2, 23).getTime() / 1000, // 2027-03-23
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.33': [
      {
        end_date: new Date(2026, 6, 29).getTime() / 1000, // 2026-07-29
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 6, 29).getTime() / 1000, // 2027-07-29
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.34': [
      {
        end_date: new Date(2026, 11, 2).getTime() / 1000, // 2026-12-02
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2027, 11, 2).getTime() / 1000, // 2027-12-02
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.35': [
      {
        end_date: new Date(2027, 2, 27).getTime() / 1000, // 2027-03-27
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2028, 2, 27).getTime() / 1000, // 2028-03-27
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
    '1.36': [
      {
        end_date: new Date(2027, 7, 2).getTime() / 1000, // 2027-08-02
        name: 'EKS Standard Support',
        type: 'GeneralSupport',
      },
      {
        end_date: new Date(2028, 7, 2).getTime() / 1000, // 2028-08-02
        name: 'EKS Extended Support',
        type: 'LongTermSupport',
      },
    ],
  },
};
